import { TReduxActions } from '../../types/redux';
import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

// oxlint-disable-next-line typescript/no-unused-vars
export function experimentsReducer(state: IExperiment[] = defaultState, action: TReduxActions): IExperiment[] {
  return state;
}
